export default [
  {
    path: '/activity-20251124-main',
    component: () => import('./Page.vue'),
    meta: { expire: '2025-12-05T23:59:59.000+08:00', title: '万圣节', id: 6 },
  },
  {
    path: '/activity-20251124-rule',
    component: () => import('./Rule.vue'),
    meta: { expire: '2025-12-05T23:59:59.000+08:00', title: '万圣节-规则', id: 6 },
  },
]
